module.exports = __webpack_public_path__ + "static/madebya-web-logo-320x320@2x.b6fc8d7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/madebya-web-logo-320x320@2x.png
// module id = 463
// module chunks = 35783957827783